module.exports = __webpack_public_path__ + "media/svg/ar-e4728893.svg";